export default __webpack_public_path__ + "static/media/Perk_1.6cdc443e.png";